"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
exports.default = {
    name: 'Carvana',
    color: {
        primary: {
            v100: '#CFEAF2',
            v200: '#00AED9',
            v300: '#018DC0',
            v400: '#00619E',
            v500: '#045489',
            v600: '#183558',
            v700: '#122946'
        },
        secondary: {
            v100: '#fbf2de',
            v200: '#feb948',
            v300: '#eb9f23'
        },
        neutral: {
            v000: '#000000',
            v100: '#ffffff',
            v200: '#F4F8FA',
            v300: '#D9DDE9',
            v400: '#AAB1C7',
            v500: '#757989'
        },
        validation: {
            warning: '#feb948',
            success: '#1dd08b',
            error: '#ff7171'
        }
    },
    grid: {
        columns: 12,
        gap: 16
    },
    breakpoint: {
        xsmall: 375,
        small: 414,
        medium: 768,
        large: 1024,
        xlarge: 1440
    },
    depth: {
        elevation: {
            v100: 'none',
            v200: '0px 2px 3px rgba(24, 53, 88, 0.1)',
            v300: '0px 6px 13px rgba(24, 53, 88, 0.1)'
        }
    },
    border: {
        radius: '3px'
    },
    font: {
        family: "'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        weight: {
            v100: '300',
            v200: '400',
            v300: '700'
        },
        display: {
            v100: styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-size: 36px;\n        line-height: 36px;\n      "], ["\n        font-size: 36px;\n        line-height: 36px;\n      "]))),
            v200: styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        font-size: 40px;\n        line-height: 40px;\n      "], ["\n        font-size: 40px;\n        line-height: 40px;\n      "]))),
            v300: styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        font-size: 54px;\n        line-height: 54px;\n      "], ["\n        font-size: 54px;\n        line-height: 54px;\n      "]))),
            v400: styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        font-size: 74px;\n        line-height: 74px;\n      "], ["\n        font-size: 74px;\n        line-height: 74px;\n      "])))
        },
        heading: {
            v100: styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        font-size: 20px;\n        line-height: 20px;\n      "], ["\n        font-size: 20px;\n        line-height: 20px;\n      "]))),
            v200: styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        font-size: 22px;\n        line-height: 24px;\n      "], ["\n        font-size: 22px;\n        line-height: 24px;\n      "]))),
            v300: styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        font-size: 24px;\n        line-height: 28px;\n      "], ["\n        font-size: 24px;\n        line-height: 28px;\n      "]))),
            v400: styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        font-size: 28px;\n        line-height: 32px;\n      "], ["\n        font-size: 28px;\n        line-height: 32px;\n      "])))
        },
        subhead: {
            v100: styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        font-size: 10px;\n        line-height: 12px;\n      "], ["\n        font-size: 10px;\n        line-height: 12px;\n      "]))),
            v200: styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        font-size: 12px;\n        line-height: 16px;\n      "], ["\n        font-size: 12px;\n        line-height: 16px;\n      "]))),
            v300: styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        font-size: 14px;\n        line-height: 16px;\n      "], ["\n        font-size: 14px;\n        line-height: 16px;\n      "]))),
            v400: styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        font-size: 16px;\n        line-height: 20px;\n      "], ["\n        font-size: 16px;\n        line-height: 20px;\n      "]))),
            v500: styled_components_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n        font-size: 18px;\n        line-height: 20px;\n      "], ["\n        font-size: 18px;\n        line-height: 20px;\n      "])))
        },
        body: {
            v100: styled_components_1.css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n        font-size: 14px;\n        line-height: 20px;\n      "], ["\n        font-size: 14px;\n        line-height: 20px;\n      "]))),
            v200: styled_components_1.css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        font-size: 16px;\n        line-height: 24px;\n      "], ["\n        font-size: 16px;\n        line-height: 24px;\n      "]))),
            v300: styled_components_1.css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n        font-size: 18px;\n        line-height: 28px;\n      "], ["\n        font-size: 18px;\n        line-height: 28px;\n      "])))
        },
        label: {
            v100: styled_components_1.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n        font-size: 12px;\n        line-height: 16px;\n      "], ["\n        font-size: 12px;\n        line-height: 16px;\n      "]))),
            v200: styled_components_1.css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n        font-size: 14px;\n        line-height: 16px;\n      "], ["\n        font-size: 14px;\n        line-height: 16px;\n      "]))),
            v300: styled_components_1.css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n        font-size: 16px;\n        line-height: 18px;\n      "], ["\n        font-size: 16px;\n        line-height: 18px;\n      "]))),
            v400: styled_components_1.css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n        font-size: 18px;\n        line-height: 20px;\n      "], ["\n        font-size: 18px;\n        line-height: 20px;\n      "])))
        },
        detail: {
            v100: styled_components_1.css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n        font-size: 12px;\n        line-height: 16px;\n      "], ["\n        font-size: 12px;\n        line-height: 16px;\n      "]))),
            v200: styled_components_1.css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n        font-size: 14px;\n        line-height: 16px;\n      "], ["\n        font-size: 14px;\n        line-height: 16px;\n      "]))),
            v300: styled_components_1.css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n        font-size: 16px;\n        line-height: 18px;\n      "], ["\n        font-size: 16px;\n        line-height: 18px;\n      "])))
        }
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;
